import React, {useState, createContext} from 'react';

const AuthorizationContext = createContext();

const AuthorizationProvider = ({ children })=>{
    const [userDetail, setUserDetail] = useState(null);
    const [flagLoggedin, setFlagLoggedin] = useState(false);
    const [path, setPath] = useState("");

    const payload = {
        userDetail,
        setUserDetail,
        flagLoggedin,
        setFlagLoggedin,
        path,
        setPath
    };

    return (
        <AuthorizationContext.Provider value={payload}>
            {children}
        </AuthorizationContext.Provider>
    )
};

export { AuthorizationProvider, AuthorizationContext };